<template>
  <ul class="services" :class="{competitor: isCompetitor}">
    <li class="inline left" v-for="service in services" :key="service.text">
      <span class="bullet" :class="$mq">
        <SvgIcon :icon="`description-${service.icon}`" class="icon" :class="position" fill></SvgIcon>
      </span>
      <div
        class="grow">
      {{ $tc(`simulation.product.service.${service.text}`, countEnergy, [$t(`simulation.product.service.invoiceFrequency.${service.param}`)])}}
      </div>
      <!--  if contract has a variable price display warning icon -->
      <SvgIcon :icon="`warning`"
               v-if="service.warning"
               class="icon icon-warning"
               @click.native="showWarningText"
      >
      </SvgIcon>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    range: null,
    position: {
      type: String,
      required: false,
      default: "first"
    }
  },
  computed: {
    services() {
      let serviceLevels = [
        "description",
        "contractType",
        "duration",
        "paymentModes",
        "invoiceModes",
        "serviceLevels"
      ];

      if (this.$parent.$options.name === "comparison") serviceLevels.shift();

      let services = [];

      let products = [];
      if (this.hasElec) products.push(this.range.electricity);
      if (this.hasGas) products.push(this.range.gas);

      serviceLevels.forEach(serviceLevel => {
        if (products[0][serviceLevel] !== undefined) {
          let same =
            products.filter(product => {
              return (
                JSON.stringify(product[serviceLevel]) ===
                JSON.stringify(products[0][serviceLevel])
              );
            }).length - 1;

          if (same) {
            let level = products[0][serviceLevel];

            level = Array.isArray(level) ? level.join("-") : level;

            services.push({
              icon: serviceLevel,
              warning: !this.isCompetitor 
                  && serviceLevel === 'contractType' 
                  && level === 'variable',
              param: !this.isCompetitor
                ? products[0].paymentFrequencies[0]
                : "empty",
              text: `${serviceLevel}.dual.${level}`
            });
          } else {
            products.forEach(product => {
              let level = product[serviceLevel];

              level = Array.isArray(level) ? level.join("-") : level;

              services.push({
                icon: serviceLevel,
                warning: !this.isCompetitor 
                  && serviceLevel === 'contractType' 
                  && level === 'variable',
                param: !this.isCompetitor
                  ? product.paymentFrequencies[0]
                  : "empty",
                text: `${serviceLevel}.${product.energyType}.${level}`
              });
            });
          }
        }
      });

      return services;
    },
    countEnergy() {
      let count = 0;
      if (this.hasElec) count += 1;
      if (this.hasGas) count += 1;

      return count;
    },
    isDual() {
      return (
        this.range.electricity !== undefined && this.range.gas !== undefined
      );
    },
    hasElec() {
      return this.range.electricity !== undefined;
    },
    hasGas() {
      return this.range.gas !== undefined;
    },
    isCompetitor() {
      return this.range.type === "competitor";
    },
  },
  methods : {
    showWarningText(){
      this.$emit('showWarning')
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-warning {
  cursor: pointer;
}

.services {
  padding: 20px;
  list-style: none;
  margin: 0;

  &.competitor {
    .icon {
      color: #4d545a!important;
    }
  }

  li {
    color: #4d545a;
    font-size: 0.9rem;
    padding: 5px;
    text-align: left;

    .icon {
      &.first {
        color: #ffc115;
      }

      color: #f1911f;
      font-size: 1.2rem;
    }
  }
}

.bullet {
  display: flex; 
  text-align: center;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: $white;
  margin-right: 10px;

  &.mobile {
    border: 1px solid $yellow;
    
    .icon {
      font-size: 0.9rem!important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/Services.vue